import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchBatches = createAsyncThunk("fetchBatches", async ({ page, limit, filters }) => {
    const params = new URLSearchParams({
        page: page || 1,
        limit: limit || 20,
        status: filters?.status || "",
        dateFrom: filters?.dateFrom || "",
        dateTo: filters?.dateTo || "",
    });

    const response = await axiosHttp.get(`replenishment/batches?${params}`);
    return response.data;
});

export const acceptEntireBatch = createAsyncThunk("acceptEntireBatch", async (batchUuid) => {
    const response = await axiosHttp.post(`replenishment/batches/${batchUuid}/accept`, {});
    return response.data;
});

const BatchDashboardSlice = createSlice({
    name: "BatchDashboardSlice",
    initialState: {
        isLoading: false,
        data: [],
        error: null,
        total: 0,
        page: 1,
        limit: 20,
        isAccepting: false,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchBatches.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchBatches.fulfilled, (state, action) => {
            state.isLoading = false;
            const payload = action.payload;
            const rawData = payload?.data;
            const arg = action.meta.arg;
            state.data = Array.isArray(rawData?.data) ? rawData.data : (Array.isArray(rawData) ? rawData : []);

            const total = rawData?.totalDocs || rawData?.total || payload?.pagination?.totalRecords || payload?.total || rawData?.count;
            if (total !== undefined) state.total = total;

            state.page = rawData?.page || payload?.pagination?.currentPage || (rawData?.offset !== undefined ? Math.floor(rawData.offset / (rawData.limit || 20)) + 1 : arg.page || 1);
        });
        builder.addCase(fetchBatches.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error?.message;
        });

        // Accept Batch
        builder.addCase(acceptEntireBatch.pending, (state) => {
            state.isAccepting = true;
        });
        builder.addCase(acceptEntireBatch.fulfilled, (state) => {
            state.isAccepting = false;
        });
        builder.addCase(acceptEntireBatch.rejected, (state, action) => {
            state.isAccepting = false;
            state.error = action.error?.message;
        });
    },
});

export default BatchDashboardSlice.reducer;
